import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import BtnComponent from '../buttonComponent/BtnComponent';
import FormComponent from '../FormComponent/FormComponent';
import {
  getErrorCodeFromGQLResponse,
  isObjectEmpty,
} from '../../shared/helper';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { useSnackbar } from 'notistack';
import { PHONE_NUMBER_EXISTS } from '../../services/userQueries/userService';
import { useMutation } from '@apollo/client';
import { ERROR_MSGS, FORGOTE_PASSWORD } from '../../shared/Strings';

const btnComponent = {
  mt: '32px',
};
const createAccountValues = {
  phonenumber: '',
};

const PasswordPage = ({ setPhoneNumber, setScreenNumber }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [validatePhoneNumber, { data, loading }] = useMutation(
    PHONE_NUMBER_EXISTS,
    {
      fetchPolicy: 'no-cache',
      onError: err => {
        const message =
          getErrorCodeFromGQLResponse(err) === 404
            ? 'User Not Found.'
            : 'Something went wrong while verifying phone number.';
        enqueueSnackbar(message, {
          variant: 'error',
        });
      },
    }
  );
  const [accountFormValues, setAccountFormValues] =
    useState(createAccountValues);
  const [accountFormErrors, setAccountFormErrors] = useState({});

  const accountHandleChange = e => {
    const { name, value } = e.target;
    setAccountFormValues({ ...accountFormValues, [name]: value });
  };

  useEffect(() => {
    if (data) {
      enqueueSnackbar(FORGOTE_PASSWORD.PHONE_NUMBER_VERIFY_SUCCESS, {
        variant: 'success',
      });
      setPhoneNumber(accountFormValues.phonenumber);
      setScreenNumber(2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const accountHandleSubmit = e => {
    e.preventDefault();
    setAccountFormErrors(accountValidate(accountFormValues));
    if (isObjectEmpty(accountValidate(accountFormValues))) {
      validatePhoneNumber({
        variables: {
          verifyUserRequest: {
            phoneNumber: accountFormValues.phonenumber,
            emailId: '',
          },
        },
      });
    }
  };
  const accountValidate = values => {
    const errors = {};

    if (!values.phonenumber) {
      errors.phonenumber = ERROR_MSGS.REQUIRED_FIELD.PHONE_NUMBER;
    } else if (values.phonenumber.length !== 10) {
      errors.phonenumber = ERROR_MSGS.PHONE_NUMBER_TEN_DIGIT;
    }

    return errors;
  };

  const inputFieldArray = [
    {
      title: FORGOTE_PASSWORD.ENTER_LINKED_PHONE,
      placeholder: FORGOTE_PASSWORD.ENTER_PHONE_NUMBER,
      helperText: FORGOTE_PASSWORD.SEND_OTP,
      type: 'text',
      onChange: accountHandleChange,
      name: 'phonenumber',
      value: accountFormValues.phonenumber,
      errorMessage: accountFormErrors.phonenumber,
    },
  ];

  return (
    <>
      <Typography variant="title" data-testid="forgotpassword">
        {FORGOTE_PASSWORD.FORGOT_PASS}
      </Typography>
      <Box sx={{ mt: '32px' }}>
        <FormComponent inputFieldArray={inputFieldArray} />
      </Box>
      <BtnComponent
        title="Send OTP"
        size="large"
        onClick={accountHandleSubmit}
        sx={btnComponent}
        fullWidth
        data-testid="sendotp-btn"
      />
      <SimpleBackdrop open={loading} />
    </>
  );
};
export default PasswordPage;
